import { IUserBaseInfo } from './userBaseInfo';
import { IAiDimensionData } from './aiDimension';
import { IFeedbackInfo } from './feedback';
import { IResourceArrInfo } from './resourceStore';

import { SwitchString } from './domainType';
import { IElementSetup } from './elementInfo';
import { AI_KEYWORD_RULE } from './homework';
import { Second, NUMBER_BOOL } from './domainType';
import { ResourceStatus, HomeworkType } from '../enums';

export interface IHomeworkResourceArrInfo extends IResourceArrInfo {
    status: ResourceStatus;
    encrypt_resource_id: string;
}

export interface IHomeworkUserInfo extends IUserBaseInfo {
    name: string;
}

export interface IHomeworkInfo {
    ai_tags: number[];
    cover_img_url: string;
    duration: number;

    /**
     * 当前用户是否已时间线点评
     */
    has_comment: number;

    /**
     * 当前用户是否已评分，0否，1是
     */
    has_score: number;

    /**
     * 0表示只有评价没评分，1表示有评分
     */
    is_score: number;
    homework_id: number;
    has_ai_report?: string;
    ai_score?: IAiDimensionData;
    homework_title: string;
    homework_type: HomeworkTypeBySession;

    /**
     * 是否优秀作业，0否，1是
     */
    is_excellent: number;

    /**
     * 是否当前用户自己的作业，0否，1是
     */
    is_self: number;

    /**
     * 是否为屏蔽状态，0否，1是
     */
    is_shield: number;
    parent_id: number;
    qrc_url: string;

    /**
     * 当前用户评分
     */
    score: number;
    share_url: string;

    /**
     * 互评得分
     */
    student_average_score: number;

    /**
     * 互评次数
     */
    student_score_num: number;
    submit_status: number;

    /**
     * 提交次数（视频作业）
     */
    retry_count: number;
    submit_ts: number;

    /**
     * 讲师评分
     */
    teacher_average_score: number;

    /**
     * 讲师评分次数
     */
    teacher_score_num: number;
    user_info: IHomeworkUserInfo;
    resource_arr: IHomeworkResourceArrInfo[];

    /**
     * 打分时的评价
     */
    comment?: string;

    /**
     * 口令
     */
    skey: string;

    feedback_info: IFeedbackInfo;
    teacher_is_score: '0' | '1';
    student_is_score: '0' | '1';

    ai_keyword_evaluation_score: number;
    keywords_task_status: KEYWORD_TASK_STATUS;

    // 动作练习相关
    ai_gesture_practice_score?: string;
    ai_gesture_practice_full_score?: string;
    ai_gesture_practice_score_limit?: string;
    ai_gesture_practice_score_detail?: IStudentGestureInfo[];
    eval_url?: string;

    student_id: string;
}

export enum KEYWORD_TASK_STATUS {
    NOT_START = '0',
    RUNNING = '1',
    DONE = '2',
    FAIL = '3',
    AI_SCORING = '4'
}

export enum KEYWORD_TASK_STATUS_CONVERT {
    RUNNING = 1,
    FAILED = 2,
    SUCCESS = 3,
}

export const KEYWORD_TASK_STATUS_2_CONVERT = {
    [KEYWORD_TASK_STATUS.NOT_START]: KEYWORD_TASK_STATUS_CONVERT.RUNNING,
    [KEYWORD_TASK_STATUS.RUNNING]: KEYWORD_TASK_STATUS_CONVERT.RUNNING,
    [KEYWORD_TASK_STATUS.DONE]: KEYWORD_TASK_STATUS_CONVERT.SUCCESS,
    [KEYWORD_TASK_STATUS.FAIL]: KEYWORD_TASK_STATUS_CONVERT.FAILED,
    [KEYWORD_TASK_STATUS.AI_SCORING]: KEYWORD_TASK_STATUS_CONVERT.RUNNING,
};

export const SESSION_TYPE_ALIAS = {
    TYPE_SURVEY: 1, // 问卷
    TYPE_ASK: 2, // 提问
    TYPE_DISCUSSION: 3, // 讨论
    TYPE_PHOTO: 4, // 拍照
    TYPE_GAME: 5, // 游戏
    TYPE_ATTENDANCE: 6, // 签到
    TYPE_MINI_COURSE: 7, // 微课
    TYPE_LOTTERY: 8, // 抽奖
    TYPE_REGISTRATION: 9, // 报名
    TYPE_QUIZ: 10, // 考试
    TYPE_VIDEO: 11, // 视频
    TYPE_LIVE: 12, // 直播
    TYPE_LIVE_PRO: 18, // 直播
    TYPE_ARTICLE: 13, // 文章
    TYPE_DOCUMENTS: 14, // 文件
    TYPE_IMAGE_ARTICLE: 15, // 图文
    TYPE_HOMEWORK: 16, // 作业
    TYPE_MEETING: 17, // 会议
    TYPE_AI_AUDIO_SLIDES: 19, // ai微课

    __NEXT__: ''
};

export enum HomeworkTypeBySession {
    VIDEO = SESSION_TYPE_ALIAS.TYPE_VIDEO,
    IMGTXT = SESSION_TYPE_ALIAS.TYPE_IMAGE_ARTICLE,
    AUDIO = SESSION_TYPE_ALIAS.TYPE_MINI_COURSE,
    DOC = SESSION_TYPE_ALIAS.TYPE_DOCUMENTS,
    GESTURE = SESSION_TYPE_ALIAS.TYPE_VIDEO
}

/**
 * 作业动作练习
 */
export interface IGestureInfo {
    id: number;
    name: string;
    gesture_cover_images: string[];
    /**
     * 动作数据 json 地址
     */
    gesture_practice_data: string;
    gesture_preview_video: string;
    /**
     * 动作视频
     */
    gesture_practice_video: string;
}

export interface IStudentGestureInfo {
    id: number;
    name: string;
    duration: Second;
    /**
     * 是否跳过动作
     */
    skip: NUMBER_BOOL;
    pass: NUMBER_BOOL;
    /**
     * 动作数据 json 地址
     */
    gesture_practice_data: string;
    gesture_preview_video: string;
    gesture_cover_images: string[];
}

export interface IHomeworkSetup extends IElementSetup {
    homework_type: HomeworkType;
    ai_voice_check_switch: SwitchString; // AI 增值功能
    ai_switch: SwitchString; // AI表现力评分开关
    ai_score_lowest_limit: string; // AI表现力最低提交分数
    ai_expressiveness_evaluation_full_score: string; // AI表现力评分满分，如果没有默认为5分
    ai_keyword_match_rule: AI_KEYWORD_RULE; // AI关键词匹配方式 0 - 关闭 1 - 精确匹配 2 - 智能匹配
    ai_keyword_evaluation_full_score: string; // AI关键词评分满分
    ai_keyword_evaluation_score_limit: string; // AI关键词最低提交分数
    ai_label: string;
}
